var Marionette = require('backbone.marionette');
var AddendumsCollection = require('../../collections/addendums-collection');
var CommonUtils = require('../../utils/common-utils.js');

var utils = new CommonUtils();

var AddendumsRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/documents/addendums-row.html'),
    events: {},

    templateContext: function () {
        var that = this;
        return {
            childId: that.model.get('child').id,
            childName: that.model.get('child').name,
            fmCreatedTime: utils.longToDateTimeFormatted(that.model.get('child').createdTime, "MMM DD YYYY")
        }
    },

    initialize: function (options) {
        //_.bindAll(this, '');
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(4), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var AddendumsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: AddendumsRowView,
    emptyView: EmptyView,

    childViewEvents: {
    },

    initialize: function (options) {
        //_.bindAll(this, 'showLoading', 'hideLoading', 'logError', 'updateModel', 'afterModelDestroy');
        this.collection = options.collection;
    },

    childViewOptions: function () {
        return {};
    }
});

var AddendumssTableView = Marionette.View.extend({
    tagName: 'div',
    className: 'addendums-table',
    template: require('../../templates/documents/addendums-table.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        }
    },

    childViewEvents: {
    },

    templateContext: function () {
        return {
        }
    },

    onRender: function () {
        this.showChildView('body', new AddendumsTableBody({
            collection: this.collection,
        }));
    },

    initialize: function (options) {
        //_.bindAll(this, 'saveConfirmed', 'onAction');
        this.collection = new AddendumsCollection(options.collectionValues);
    }
});

module.exports = AddendumssTableView;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/addendums-table-view.js
// module id = 409
// module chunks = 0